import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, ref } from 'vue';
import { AxiosError } from 'axios';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { changePassword as _changePassword } from '@/api/user';
import { BModal } from 'bootstrap-vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ['input', 'password-changed'],
  setup(__props: any, { emit }) {

const props = __props as {
    value: boolean;
};





const currentPassword = ref('');
const newPassword = ref('');
const confirmNewPassword = ref('');

const savingPassword = ref(false);
const passwordChanged = ref(false);
const invalidPassword = ref(false);
const errorMessage: Ref<string | null> = ref(null);

const isVisible = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        if (value) {
            errorMessage.value = null;
            passwordChanged.value = false;
            currentPassword.value = '';
            newPassword.value = '';
            confirmNewPassword.value = '';
        }
        emit('input', value);
    }
});

const changePassword = async () => {
    try {
        savingPassword.value = true;
        errorMessage.value = null;

        if (currentPassword.value && newPassword.value && confirmNewPassword.value) {
            await _changePassword(currentPassword.value, newPassword.value, confirmNewPassword.value);
        }
        passwordChanged.value = true;
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 400) {
            if (axiosError.response.data.Message) {
                if (axiosError.response.data.Message === 'Invalid Password') {
                    invalidPassword.value = true;
                } else {
                    errorMessage.value = axiosError.response.data.Message;
                }
            }
        } else {
            errorMessage.value = 'Fatal error';
            window.rumReportError(axiosError);
        }
    } finally {
        savingPassword.value = false;
    }
};

const onPasswordChanged = () => {
    emit('password-changed');
};

return { __sfc: true,emit, props, currentPassword, newPassword, confirmNewPassword, savingPassword, passwordChanged, invalidPassword, errorMessage, isVisible, changePassword, onPasswordChanged, ValidationProvider, ValidationObserver, BModal, LoaderBtn }
}

})